/** @type {import('tailwindcss').Config} */

import tailwindcssPrimeUI from 'tailwindcss-primeui';
import tailwindcssFullBleed from 'tailwindcss-full-bleed';
import tailwindAnimate from 'tailwindcss-animated';

export const colors = {
  orange: {
    50: '#fff7ed',
    100: '#ffedd5',
    200: '#fed7aa',
    300: '#fdba74',
    400: '#fcae07',
    500: '#fd9717', // <- Default orange-500
    600: '#ea580c',
    700: '#c2410c',
    800: '#9a3412',
    900: '#7c2d12',
    gradientStart: '#fcae07',
  },
  blue: {
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#376ef7',
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
    950: '#172554',
    gradientStart: '#4f9efd'
  },
  slate: {
    200: '#F9F7F5'
  },
} as const;

const config = {
  content: [
    "./src/**/*.{html, ts}",
  ],
  theme: {
    fontFamily: {
      font: ["Roboto"],
    },
    extend: {
      screens: {
        'thin': { max: '385px' }, // Applies when screen is 360px or less,
        'medium-thin': { max: '500px' }, // Applies when screen is 425px or less
        'hoverable': {'raw': '(hover: hover) and (pointer: fine)'},
      },
      spacing: {
        pagePadX: '1.5rem',
        pagePadXSmall: '1rem',
        pagePadY: '1.75rem',
        insetTop: 'env(safe-area-inset-top, 0px)'
      },
      aspectRatio: {
        '3/2': '3 / 2',
        '6/5': '6 / 5',
      },
      fontSize: {
        "label": "0.80rem",
        "icon-lg": "1.5rem",
      },
      colors,
      keyframes: {
        slideInDown: {
          '0%': { transform: 'translateY(-100%)' },
          '100%': { transform: 'translateY(0)' },
        },
      },
      animation: {
        slideInDown: 'slideInDown 4s ease-in-out forwards',
      },
    },
  },
  darkMode: "false",
  safelist: [
    'bg-blue-500',
    'bg-orange-500',
    'bg-green-500',
    'bg-red-500',
    'bg-blue-400',
    'bg-gray-400',
    'animate-pulse',
    'py-3',
    'aspect-square',
    'aspect-4/3',
    'h-full',
    'flex-grow',
    'container',
    'bg-surface-200',
    'p-4',
    'mr-auto',
    '!mr-auto',
    "font-medium",
    "font-semibold",
    "font-bold"
  ],
  plugins: [
    tailwindcssPrimeUI,
    tailwindcssFullBleed,
    tailwindAnimate
  ]
}

export default config;
